import ComparisonPdfModal from './ComparisonPdfModal'
import comparisonPdfModalContainer from './comparisonPdfModalContainer'

export default comparisonPdfModalContainer(ComparisonPdfModal)
